
<div class="card-body">
    <div class="row"><h5> {{origin}}: &nbsp;<strong>{{display_name}}</strong></h5> <br/></div>
    <br/>

    <!-- induction summary panel -->
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>	   
        <div widget class="card border-0 box-shadow selected-column" *ngIf="!loadingIndicator">
            <div class="card-header transparent border-0 text-muted">
                <h5 class="mb-0">Induction Summary:</h5>
            </div>
            <div class="card-body pt-0 widget-body">
                <div class="row">
                    <div *ngIf="certificate" class="col-md-6">
                        Job Role: <strong>{{certificate.induction_set_name}}</strong> <br/>
                        Last Induction Set Completed: <strong>{{certificate.induction_set_description}}</strong> <br/>
                        Completed at: <strong>{{ (formatDate(certificate.date_done) !== null && certificate.date_done != '0000-00-00') ? (formatDate(certificate.date_done) | date: 'dd MMM yyyy') : "No Date"}} </strong><br/><br/>
                        <a *ngIf="certificate.certificate_file!='' && certificate.certificate_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{certificate.certificate_file}}" target="_new" title="View Certificate File"><i class="fa fa-certificate"></i>  Induction Approval Certificate<br/></a>
                        <a *ngIf="certificate.approval_file!='' && certificate.approval_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{certificate.approval_file}}" target="_new" title="View Approval Letter File"><i class="fa fa-certificate"></i>  Induction Approval Letter<br/></a>
                        <a *ngIf="certificate.declaration_file!='' && certificate.declaration_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{certificate.declaration_file}}" target="_new" title="View {{origin}} Declaration File"><i class="fa fa-certificate"></i>  {{origin}} Responsibility Statement<br/></a>
                        <a *ngIf="certificate.checklist_file!='' && certificate.checklist_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{certificate.checklist_file}}" target="_new" title="View Training Checklist File"><i class="fa fa-certificate"></i>  Training Checklist<br/></a>
                    </div>
                    <div class="col-md-6">
                        <div *ngIf="induction_tasks.length > 0"> 
                            Status: <h5><strong class="text-gray" *ngIf="has_pending">PENDING</strong><strong class="text-success" *ngIf="!has_pending">COMPLETED</strong> <br/></h5>
                            Current Set Induction in Progress: <br/>
                            <div *ngFor='let pending of induction_tasks'>
                                    <div *ngIf="pending.set_task_count == pending.done_set_task_count && !loadingIndicator">
                                        <small><strong>{{pending.set_name}}</strong> - <strong>100%</strong></small> <br/>
                                        <div class="progress mb-2">
                                            <div class="progress-bar bg-success" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{pending.done_set_task_count}} out of {{pending.set_task_count}}</div>
                                        </div>
                                    </div>
                                    <div *ngIf="pending.set_task_count != pending.done_set_task_count && !loadingIndicator">
                                        <small><strong>{{pending.set_name}}</strong> - <strong>{{((pending.done_set_task_count / pending.set_task_count) * 100) | number: '2.0-0'}} % - {{pending.done_set_task_count}} out of {{pending.set_task_count}}</strong></small> <br/>
                                        <div class="progress mb-2" *ngIf="pending.done_set_task_count != pending.set_task_count">
    
                                            <div *ngIf="pending.done_set_task_count > 0" class="progress-bar bg-warning" role="progressbar" [ngStyle]="{'width': + ((pending.done_set_task_count / pending.set_task_count) * 100)  + '%'}" aria-valuenow="(((pending.done_set_task_count / pending.set_task_count) * 100) | number : '2.0-0')" aria-valuemin="0" aria-valuemax="100">{{pending.done_set_task_count}} out of {{pending.set_task_count}}</div>
                                            <div *ngIf="pending.done_set_task_count == 0" class="progress-bar bg-gray" role="progressbar" style="width: 100%;" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">{{pending.done_set_task_count}} out of {{pending.set_task_count}}</div>
                                        
                                        </div>
                                    </div>
                                </div>
                        </div>
                        <div *ngIf="induction_tasks.length==0">  
                            Status: <h5><strong class="text-success">No Training.</strong></h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <br />
    
    <div class="clearfix">            
        <ul class="nav nav-tabs tabs-success custom top">
            <li class="nav-item dropdown">
                <a class="nav-link active" data-toggle="tab" href="#records" (click)="onTabSelectChange('records')">Induction Records</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#certificates" (click)="onTabSelectChange('certificates')">Induction Certificates</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#history">Induction History</a>
            </li> 
        </ul>
    </div>
    <div class="tab-content top">
        <!-- induction records -->
        <div class="tab-pane active" id="records">
            
            <button type="button" [disabled]="induction_count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
                <i class="fa fa-lg fa-check-square-o"></i><span>&nbsp; Columns</span>
            </button>&nbsp;
            <div class="dropdown-menu fs-12" style="width: 150px;">
                <div class="col-md-12 mb-3 fs-12">
                    <input type="checkbox" [(ngModel)]="showTaskName">&nbsp;Task Name<br />
                    <input type="checkbox" [(ngModel)]="showTaskType">&nbsp;Task Type<br />
                    <input type="checkbox" [(ngModel)]="showStatus">&nbsp;Status<br />
                    <input type="checkbox" [(ngModel)]="showDateDone">&nbsp;Date Done<br /> 
                    <input type="checkbox" [(ngModel)]="showTaskExpiry">&nbsp;Task Expiry<br />
                    <input type="checkbox" [(ngModel)]="showFile">&nbsp;File<br />
                </div>
            </div>
            <button type="button" [disabled]="induction_count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" placement="bottom" ngbTooltip="Print List" (click)="printer.print('induction-print-section', 'Induction Records')">
                <i class="fa fa-lg fa-print"></i>
                <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Print</span>
            </button>
    
            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="induction_rows.length < 1">
                    <i class="fa fa-lg fa-download"></i><span>&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                    <a (click)="exportToCSV('inductions', induction_rows)" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                    <a (click)="exportToExcel('inductions', induction_rows)" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                    <a (click)="exportToPDF('inductions', induction_rows)" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>  
            
            <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm btn-secondary tt mb-1 mr-1"
                (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                <i class="fa fa-lg fa-filter"></i>
                <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Filter</span>
            </button>

            <button type="button" [disabled]="induction_count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                <i class="fa fa-lg fa-toggle-right"></i><span>&nbsp; Sidebar</span>
            </button>  
            <br/>
            <br/>
            <div class="col-12" *ngIf="induction_count > 0">
                <ngx-loading [show]="loadingIndicator"></ngx-loading>
                <div class="row">
                    <div [ngClass]="(showSidebar) ? 'col-md-8' : 'col-md-12'">
                    <!-- START OF INDUCTION TABLE-->
                        <div class="row mb-0 pb-0">
                            <div class="col-md-12">
                                <button (click)="openModalBulkMarkForRetrain()" class="btn btn-sm btn-success pull-left" *ngIf="mark_bulk">RETRAIN</button>
                                <a (click)="openModalReinduction()"><span class="badge badge-pill badge-warning pull-right"><span><i class="fa fa fa-mortar-board">&nbsp;</i></span>Mark {{origin}} for Reinduction</span></a>&nbsp;
                                <a (click)="bulkRetrain()"><span class="badge badge-pill badge-dispatched pull-right"><span><i class="fa fa fa-square-o"></i>&nbsp;</span>Mark Multiple Inductions for Retraining</span></a>&nbsp;
                                <a (click)="resetInductionFilters()"><span class="badge badge-pill badge-success pull-right"><span><i class="fa fa fa-list"></i>&nbsp;</span>Reset Filter</span></a><br/>
                            </div>
                            <br/>
                        </div>
                        <ngx-datatable 
                            *ngIf="!loadingIndicator"
                            [loadingIndicator]="loadingIndicator"
                            class="material"
                            [rows]="induction_rows"
                            [columnMode]="'force'"
                            [footerHeight]="40"
                            [headerHeight]="30"
                            [rowHeight]="'auto'"
                            [limit]="10"
                            [selected]="selected"
                            (select)='onSelect($event)'
                            [selectionType]="sType" 
                            [scrollbarH]="true"
                            [headerHeight]="showFilters?50:30">

                            <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false" cellClass="is-dispatched"
                                [headerCheckboxable]="true" [checkboxable]="getCheckboxStatus" *ngIf="mark_bulk">
                            </ngx-datatable-column>

                            <ngx-datatable-column prop="record_id" name="Operations" headerClass="header" [width]="70"> 
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                    <div align="left">
                                        <!-- <a *ngIf="value != null && value !=''" class="cursorhover" title="Reset Induction" (click)="openResetModal(row)"><i class="fa fa-lg fa-rotate-left"></i>&nbsp;</a>  -->
                                        <a *ngIf="(value != null && value !='') && row.set_tasks_task_type_id !=2" class="cursorhover" title="Retrain Induction" (click)="openRetrainModal(row)"><i class="fa fa-lg fa-rotate-left"></i>&nbsp;</a>
                                        <a  *ngIf="(value != null && value !='')" class="cursorhover" title="Delete Induction" (click)="openDeleteModal(row)"><i class="fa fa-lg fa-trash"></i></a>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                                                
                            <ngx-datatable-column name="Task Name" prop="set_tasks_title"  headerClass="header"  *ngIf="showTaskName" [sortable]="true">
                                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                                    <span (click)="sort()">{{column.name}}</span>
                                    <span *ngIf="showFilters">
                                        <input type="text" [(ngModel)]="filterTaskTitle" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                    </span>
                                </ng-template>
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                                    <div align="left"  style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">{{row.set_tasks_title}}</div>
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Task Type" prop="set_task_type_name"  headerClass="header" *ngIf="showTaskType" [sortable]="true">
                                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                                    <span (click)="sort()">{{column.name}}</span>
                                    <span *ngIf="showFilters">
                                        <input type="text" [(ngModel)]="filterTaskType" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                    </span>
                                </ng-template>
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                                    <div align="left"  style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">{{row.set_task_type_name}}</div>
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Status" prop="record_date_finish"  headerClass="header" [width]="90" *ngIf="showStatus" [sortable]="true">
                                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                                    <span (click)="sort()">{{column.name}}</span>
                                    <span *ngIf="showFilters">
                                        <input type="text" [(ngModel)]="filterStatus" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                    </span>
                                </ng-template>
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                    <div *ngIf="checkStatus(row) == 'COMPLETED' && row.record_status != 1" class="text-success">Completed</div>
                                    <div *ngIf="checkStatus(row) == 'PENDING'" class="text-gray">Pending</div>
                                    <div *ngIf="checkStatus(row) == 'EXPIRED' && row.record_status == 0" style="color:red">Expired</div>
                                    <div *ngIf="checkStatus(row) == 'COMPLETED-PASSED'" class="text-success">Completed - Passed</div>
                                    <div *ngIf="checkStatus(row) == 'COMPLETED-FAILED'" class="text-danger">Completed - Failed</div>
                                    <small *ngIf="row.file_status == 0"><i class="text-warning">FILE UNVERIFIED</i><br/></small>
                                    <small *ngIf="row.record_status == 1"><i class="text-warning">FILE DELETED</i></small>
                                    <small *ngIf="row.record_status == 2"><i class="text-warning">RESET</i></small>
                                    <small *ngIf="row.record_status == 3"><i class="text-warning">RETRAIN</i></small>
                                    <small *ngIf="row.record_status == 4"><i class="text-warning">REINDUCTION</i></small>
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Date Done" prop="record_date_finish"  headerClass="header" [width]="90" *ngIf="showDateDone" [sortable]="true">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    {{ (formatDate(value) != null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Task Expiry" prop="record_expiry"  headerClass="header" [width]="90" *ngIf="showTaskExpiry" [sortable]="true">
                                    <ng-template let-value="value" ngx-datatable-cell-template>
                                        {{ (formatDate(value) != null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                                    </ng-template>
                            </ngx-datatable-column>
        
                         
                            <ngx-datatable-column name="File" prop="record_filename"  headerClass="header" *ngIf="showFile" [sortable]="true">
                                <ng-template let-column="column" let-sort="sortfn" ngx-datatable-header-template>
                                    <span (click)="sort()">{{column.name}}</span>
                                    <span *ngIf="showFilters">
                                        <input type="text" [(ngModel)]="filterFile" style="height:17px" 
                                            class="pt-1 pb-0 mt-0 mb-0 noborder input-sm form-control form-control-sm"
                                            (keyup)="updateFilter()" />
                                    </span>
                                </ng-template>
                                <ng-template let-row="row" ngx-datatable-cell-template >
                                    <div *ngIf="row.record_filename != null && row.record_file_name != ''" style="overflow-wrap: break-word;">
                                        <a *ngIf="row.filename_path != null && row.filename_path != ''" href="{{fileStoragePath}}/{{row.filename_path}}/{{row.record_filename}}" target="_new">{{row.record_filename}}</a>
                                        <a *ngIf="row.filename_path == null || row.filename_path == ''" href="{{fileStoragePath}}/{{folder_path}}/{{row.record_filename}}" target="_new">{{row.record_filename}}</a>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
        
                        </ngx-datatable>
                    </div>
                    <div class="col-md-4" *ngIf="showSidebar">
                        <div widget class="card border-0 box-shadow selected-column">
                            <div class="card-header transparent border-0 text-muted">
                                <h5 class="mb-0">Details:</h5>
                            </div>
                            <div class="card-body pt-0 widget-body">
                                <ul>                                                    
                                    <div *ngIf="selected[0]">
                                        <div class="col-md-12">
                                            <h4 class="text-primary">{{selected[0]["set_tasks_title"]}}<br /></h4><span *ngIf="selected[0].record_filename != null && selected[0].record_filename != ''">
                                                    <a *ngIf="selected[0].filename_path != null && selected[0].filename_path != ''" href="{{fileStoragePath}}/{{selected[0].filename_path}}/{{selected[0].record_filename}}" target="_new" class="text-primary"><i class="fa fa-lg fa-folder"></i> {{selected[0].record_filename}}</a>
                                            <a *ngIf="selected[0].filename_path == null || selected[0].filename_path == ''" href="{{fileStoragePath}}/{{folder_path}}/{{selected[0].record_filename}}" target="_new" class="text-primary"><i class="fa fa-lg fa-folder"></i> {{selected[0].record_filename}}</a></span><br>
                                            Status: <h4>
                                                    <span *ngIf="checkStatus(selected[0]) == 'COMPLETED' && selected[0].record_status != 1" class="text-success">Completed</span>
                                                    <span *ngIf="checkStatus(selected[0]) == 'PENDING'" class="text-gray">Pending</span>
                                                    <span *ngIf="checkStatus(selected[0]) == 'EXPIRED' && selected[0].record_status == 0" style="color:red">Expired</span>
                                                    <div *ngIf="checkStatus(selected[0]) == 'COMPLETED-PASSED'" class="text-success">Completed - Passed</div>
                                                    <div *ngIf="checkStatus(selected[0]) == 'COMPLETED-FAILED'" class="text-danger">Completed - Failed</div><br/>
                                                    <small *ngIf="selected[0].file_status == 0"><i class="text-warning">FILE UNVERIFIED<br/></i></small>
                                                    <small *ngIf="selected[0].record_status == 1"><i class="text-warning">FILE DELETED</i></small>
                                                    <small *ngIf="selected[0].record_status == 2"><i class="text-warning">RESET</i></small>
                                                    <small *ngIf="selected[0].record_status == 3"><i class="text-warning">RETRAIN</i></small>
                                                    <small *ngIf="selected[0].record_status == 4"><i class="text-warning">REINDUCTION</i></small>
                                            </h4>
                                            Completed Date: <strong class="text-primary">{{ (formatDate(selected[0].record_date_finish) !== null && selected[0].record_date_finish != '0000-00-00') ? (formatDate(selected[0].record_date_finish) | date: 'dd MMM yyyy') : "No Date"  }}</strong><br />
                                            Description: <strong class="text-primary">{{selected[0].set_description}}</strong> <br />
                                        </div>
                                        <div class="col-md-12" *ngIf="selected[0].record_id != null && selected[0].record_id !=''"><br />
                                            <!-- <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openResetModal(sel);">
                                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-rotate-left"></i></span>
                                                Reset Induction
                                            </button>&nbsp; -->
                                            <button  *ngIf="selected[0].set_tasks_task_type_id !=2" type="button" class="btn btn-sm btn-secondary mb-1" (click)="openRetrainModal(selected[0]);">
                                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-rotate-left"></i></span>
                                                Retrain Induction
                                            </button>&nbsp;
                                            <button type="button" class="btn btn-sm btn-danger mb-1" (click)="openDeleteModal(selected[0])">
                                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-trash"></i></span>
                                                Delete
                                            </button>
                                        </div>
                                    </div>
                                </ul>         
                                <div *ngIf="!selected.length">
                                    &nbsp;&nbsp;No Selection.
                                </div>
                             </div>
                        </div><br>
                        <!-- <div *ngIf="certificates.length > 1" widget class="card border-0 box-shadow selected-column">
                            <div class="card-header transparent border-0 text-muted">
                                <h5 class="mb-0">Previous Induction Set Completed:</h5>
                            </div>
                            <div class="card-body pt-0 widget-body">
                                <ul>
                                    <div style="overflow-y: auto; max-height:120px;">
                                        <div *ngFor="let set of certificates | slice:1">
                                            <small>{{set.induction_set_description}} <strong>{{ (formatDate(set.date_done) !== null && set.date_done != '0000-00-00') ? (formatDate(set.date_done) | date: 'dd MMM yyyy') : "No Date"  }}</strong></small>
                                        </div>
                                    </div>
                                </ul>         
                                </div>
                        </div> -->
                    </div>
                </div>
        
            </div>
            <p *ngIf="induction_count == 0">No induction record for this {{origin | lowercase}}.</p>
        </div>

        <!-- induction certificates -->
        <div class="tab-pane" id="certificates">
            <button type="button" [disabled]="certificates_count == 0" class="btn btn-secondary btn-sm dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="sr-only">Toggle Dropdown</span>
                <i class="fa fa-lg fa-check-square-o"></i><span>&nbsp; Columns</span>
            </button>&nbsp;
            <div class="dropdown-menu fs-12" style="width: 150px;">
                <div class="col-md-12 mb-3 fs-12">
                    <input type="checkbox" [(ngModel)]="showSetName">&nbsp;Induction Set Name<br />
                    <input type="checkbox" [(ngModel)]="showSetDescription">&nbsp;Induction Set Description<br />
                    <input type="checkbox" [(ngModel)]="showDateDone2">&nbsp;Date Done<br />
                    <input type="checkbox" [(ngModel)]="showTimeDone">&nbsp;Time Done<br /> 
                    <input type="checkbox" [(ngModel)]="showCertificate">&nbsp;Certificate File<br />
                    <input type="checkbox" [(ngModel)]="showApproval">&nbsp;Approval Letter<br />
                    <input type="checkbox" [(ngModel)]="showDeclaration">&nbsp;Responsibility Statement<br />
                    <input type="checkbox" [(ngModel)]="showTraining">&nbsp;Training Checklist<br />
                </div>
            </div>
            <button type="button" [disabled]="certificates_count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" placement="bottom" ngbTooltip="Print List" (click)="printer.print('certificates-print-section', 'Induction Cerificates')">
                <i class="fa fa-lg fa-print"></i>
                <span *ngIf="s_theme.menu_type == 'default'">&nbsp; Print</span>
            </button>
            <div class="btn-group mr-1">
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="certificates.length < 1">
                    <i class="fa fa-lg fa-download"></i><span>&nbsp; Export</span>
                </button>
                <div class="dropdown-menu fs-12">
                    <a (click)="exportToCSV('certificates', certificates)" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                    <a (click)="exportToExcel('certificates', certificates)" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                    <a (click)="exportToPDF('certificates', certificates)" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                </div>
            </div>  
            <button type="button" [disabled]="certificates_count == 0" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="toggleSideBar2()" placement="bottom" ngbTooltip="Toggle Sidebar">
                <i class="fa fa-lg fa-toggle-right"></i><span>&nbsp; Sidebar</span>
            </button>  
            <br/>
            <br/>
            <div class="col-12" *ngIf="certificates_count > 0">
                <ngx-loading [show]="loadingIndicator"></ngx-loading>
                <div class="row">
                    <div [ngClass]="(showSidebar2) ? 'col-md-8' : 'col-md-12'">
                    <!-- START OF CERTIFICATES-->
                        <ngx-datatable 
                            *ngIf="certificates_count > 0 && !loadingIndicator"
                            [loadingIndicator]="loadingIndicator"
                            class="material"
                            [rows]="certificates"
                            [columnMode]="'force'"
                            [footerHeight]="40"
                            [headerHeight]="30"
                            [rowHeight]="'auto'"
                            [limit]="10"
                            [selected]="selected2"
                            (select)='onSelect2($event)'
                            [selectionType]="'single'"
                            [scrollbarH]="true"
                            >
                            
                            <ngx-datatable-column name="Induction Set Name" prop="induction_set_name"  headerClass="header"  *ngIf="showSetName">
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                                    <div align="left"  style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">{{row.induction_set_name}}</div>
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Description" prop="induction_set_description"  headerClass="header" *ngIf="showSetDescription">
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                                    <div align="left"  style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">{{row.induction_set_description}}</div>
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Date Done" prop="date_done"  headerClass="header" [width]="90" *ngIf="showDateDone2">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    {{ (formatDate(value) != null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                                </ng-template>
                            </ngx-datatable-column>
        
                            <ngx-datatable-column name="Time Done" prop="time_done"  headerClass="header" [width]="90" *ngIf="showTimeDone">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    {{ (value !== null) ? ('1999-01-01 ' + value | date: 'h:mm a') : "No Record"  }}
                                </ng-template>                              
                            </ngx-datatable-column>
        
                         
                            <ngx-datatable-column name="Certificate File" prop="certificate_file"  headerClass="header" *ngIf="showCertificate">
                                <ng-template let-row="row" ngx-datatable-cell-template >
                                    <a *ngIf="row.certificate_file!='' && row.certificate_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{row.certificate_file}}" target="_new" title="View Certificate File"><i class="fa fa-certificate text-success"></i>  {{row.certificate_file}}<br/></a>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Approval Letter" prop="approval_file"  headerClass="header" *ngIf="showApproval">
                                <ng-template let-row="row" ngx-datatable-cell-template >
                                    <a *ngIf="row.approval_file!='' && row.approval_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{row.approval_file}}" target="_new" title="View Approval Letter"><i class="fa fa-certificate text-success"></i>  {{row.approval_file}}<br/></a>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Responsibility Statement" prop="declaration_file"  headerClass="header" *ngIf="showDeclaration">
                                <ng-template let-row="row" ngx-datatable-cell-template >
                                    <a *ngIf="row.declaration_file!='' && row.declaration_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{row.declaration_file}}" target="_new" title="View Declaration File"><i class="fa fa-certificate text-success"></i>  {{row.declaration_file}}<br/></a>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Training Checklist" prop="checklist_file"  headerClass="header" *ngIf="showTraining">
                                <ng-template let-row="row" ngx-datatable-cell-template >
                                    <a *ngIf="row.checklist_file!='' && row.checklist_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{row.checklist_file}}" target="_new" title="View Training Checklist"><i class="fa fa-certificate text-success"></i>  {{row.checklist_file}}<br/></a>
                                </ng-template>
                            </ngx-datatable-column>
        
                        </ngx-datatable>
                    </div>

                    <div class="col-md-4" *ngIf="showSidebar2">
                        <div widget class="card border-0 box-shadow selected-column">
                            <div class="card-header transparent border-0 text-muted">
                                <h5 class="mb-0">Details:</h5>
                            </div>
                            <div class="card-body pt-0 widget-body">
                                <ul>                                                    
                                    <div *ngFor='let sel2 of selected2'>
                                        <div class="col-md-12">
                                            <h4 class="text-primary">{{sel2.induction_set_name}}<br /></h4><br />
                                            Description: <strong class="text-primary">{{sel2.induction_set_description}}</strong><br />
                                            Date Done: <strong class="text-primary">{{ (formatDate(sel2.date_done) !== null && sel2.date_done != '0000-00-00') ? (formatDate(sel2.date_done) | date: 'dd MMM yyyy') : "No Date"  }}</strong><br />
                                            Time Done: <strong class="text-primary">{{ (sel2.time_done !== null) ? ('1999-01-01 ' + sel2.time_done | date: 'h:mm a') : "No Record"  }}</strong><br />       
                                            Certificate File: <a *ngIf="sel2.certificate_file!='' && sel2.certificate_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{sel2.certificate_file}}" target="_new" title="View Certificate File" class="text-primary"><i class="fa fa-certificate text-success"></i>  {{sel2.certificate_file}}</a><br/>                                     
                                            Approval Letter: <a *ngIf="sel2.approval_file!='' && sel2.approval_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{sel2.approval_file}}" target="_new" title="View Approval Letter" class="text-primary"><i class="fa fa-certificate text-success"></i>  {{sel2.approval_file}}</a><br/>
                                            Responsibility Statement: <a *ngIf="sel2.declaration_file!='' && sel2.declaration_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{sel2.declaration_file}}" target="_new" title="View Declaration File" class="text-primary"><i class="fa fa-certificate text-success"></i>  {{sel2.declaration_file}}</a><br/>
                                            Training Checklist: <a *ngIf="sel2.checklist_file!='' && sel2.checklist_file!=null" href="{{fileStoragePath}}/{{folder_path}}/{{sel2.checklist_file}}" target="_new" title="View Training Checklist" class="text-primary"><i class="fa fa-certificate text-success"></i>  {{sel2.checklist_file}}</a><br/>
                                        </div>
                                    </div>
                                </ul>         
                                <div *ngIf="!selected2.length">
                                    &nbsp;&nbsp;No Selection.
                                </div>
                             </div>
                        </div><br>
                    </div>
        
                </div>
            </div>
            <p *ngIf="certificates_count == 0">No certificate for this {{origin | lowercase}}.</p>
        </div>
        <!-- induction history -->
        <div class="tab-pane" id="history">
            <br />
            <div class="col-12" *ngIf="history_count > 0">
                <ngx-loading [show]="loadingIndicator"></ngx-loading>
                <div class="row">
                    <div class="col-md-12">
                    <!-- START OF HISTORY LOGS-->
                        <ngx-datatable 
                            *ngIf="history_count > 0 && !loadingIndicator"
                            [loadingIndicator]="loadingIndicator"
                            class="material"
                            [rows]="induction_history"
                            [columnMode]="'force'"
                            [footerHeight]="40"
                            [headerHeight]="30"
                            [rowHeight]="'auto'"
                            [limit]="10"
                            [selectionType]="'single'"
                            [scrollbarH]="true"
                            >
                            
                            <ngx-datatable-column name="Induction Set Name" prop="induction_set_name"  headerClass="header">
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                                    <div align="left"  style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">{{row.induction_set_name}}</div>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Induction Set Task" prop="task_name"  headerClass="header">
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
                                    <div align="left"  style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">{{row.task_name}}</div>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Log details" prop="description"  headerClass="header" [width]="90"></ngx-datatable-column>
        
                            <ngx-datatable-column name="Created Date" prop="created_at"  headerClass="header" [width]="90">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    {{ (formatDate(value) != null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Created By" prop="created_name"  headerClass="header" [width]="90"></ngx-datatable-column>
        
                        </ngx-datatable>
                    </div>
                </div>
            </div>
            <p *ngIf="history_count == 0">No induction history logs for this {{origin |lowercase}}.</p>
        </div>
    </div>

   
</div>


<!-- START PRINT-->
<div id="induction-print-section" style="display:none">
    <table style="width:100%">
              
        <thead>
            <tr> 
                <th *ngIf="showTaskName"><small><strong>Task Name</strong></small></th> 
                <th *ngIf="showTaskType"><small><strong>Task Type</strong></small></th>
                <th *ngIf="showStatus"><small><strong>Status</strong></small></th>                      
                <th *ngIf="showDateDone"><small><strong>Date Done</strong></small></th>
                <th *ngIf="showTaskExpiry"><small><strong>Task Expiry</strong></small></th>
                <th *ngIf="showFile"><small><strong>File</strong></small></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let induction of induction_rows">                        
                <td class="text-muted" *ngIf="showTaskName"><small>{{induction.set_tasks_title}}</small></td>
                <td class="text-muted" *ngIf="showTaskType"><small>{{induction.set_task_type_name}}</small></td>
                <td class="text-muted" *ngIf="showStatus"><small>
                    <div *ngIf="checkStatus(induction) == 'COMPLETED' && induction.record_status != 1" class="text-success">Completed</div>
                    <div *ngIf="checkStatus(induction) == 'PENDING'" class="text-gray">Pending</div>
                    <div *ngIf="checkStatus(induction) == 'EXPIRED' && induction.record_status == 0" class="text-danger">Expired</div>
                    <div *ngIf="checkStatus(induction) == 'COMPLETED-PASSED'" class="text-success">Completed - Passed</div>
                    <div *ngIf="checkStatus(induction) == 'COMPLETED-FAILED'" class="text-danger">Completed - Failed</div>
                    <small *ngIf="induction.record_status == 1"><i style="color:black">FILE DELETED</i></small>
                    <small *ngIf="induction.record_status == 2"><i style="color:black">RESET</i></small>
                    <small *ngIf="induction.record_status == 3"><i style="color:black">RETRAIN</i></small>
                    <small *ngIf="induction.record_status == 4"><i style="color:black">REINDUCTION</i></small>                    
                </small></td>
                <td class="text-muted" *ngIf="showDateDone"><small> {{ (formatDate(induction.record_date_finish) != null && induction.record_date_finish != '0000-00-00') ? (formatDate(induction.record_date_finish) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td class="text-muted" *ngIf="showTaskExpiry"><small>{{ (formatDate(induction.record_expiry) != null && induction.record_expiry != '0000-00-00') ? (formatDate(induction.record_expiry) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td class="text-muted" *ngIf="showFile"><small>{{induction.record_filename}}</small></td>
            </tr>
        </tbody>
    
    </table>
</div>

<div id="certificates-print-section" style="display:none">
    <table style="width:100%">
              
        <thead>
            <tr> 
                <th *ngIf="showSetName"><small><strong>Induction Set Name</strong></small></th> 
                <th *ngIf="showSetDescription"><small><strong>Description</strong></small></th>
                <th *ngIf="showDateDone2"><small><strong>Date Done</strong></small></th>                      
                <th *ngIf="showTimeDone"><small><strong>Time Done</strong></small></th>
                <th *ngIf="showCertificate"><small><strong>Certificate File</strong></small></th>
                <th *ngIf="showApproval"><small><strong>Approval Letter</strong></small></th>
                <th *ngIf="showDeclaration"><small><strong>Responsibility Statement</strong></small></th>
                <th *ngIf="showTraining"><small><strong>Training Checklist</strong></small></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let certificate of certificates">                        
                <td class="text-muted" *ngIf="showSetName"><small>{{certificate.induction_set_name}}</small></td>
                <td class="text-muted" *ngIf="showSetDescription"><small>{{certificate.induction_set_description}}</small></td>
                <td class="text-muted" *ngIf="showDateDone2"><small> {{ (formatDate(certificate.date_done) != null && certificate.date_done != '0000-00-00') ? (formatDate(certificate.date_done) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td class="text-muted" *ngIf="showTimeDone"><small>{{ (certificate.time_done !== null) ? ('1999-01-01 ' + certificate.time_done | date: 'h:mm a') : "No Record"  }}</small></td>
                <td class="text-muted" *ngIf="showCertificate"><small>{{certificate.certificate_file}}</small></td>
                <td class="text-muted" *ngIf="showApproval"><small>{{certificate.approval_file}}</small></td>
                <td class="text-muted" *ngIf="showDeclaration"><small>{{certificate.declaration_file}}</small></td>
                <td class="text-muted" *ngIf="showTraining"><small>{{certificate.checklist_file}}</small></td>
            </tr>
        </tbody>
    
    </table>
</div>


<!-- END PRINT -->

    
<!-- START OF DELETE OBJECT FORM -->
<ng-template #modalDeleteInductionRecord let-close="close">
        <div class="modal-header">
            <h5 class="modal-title">Delete Induction</h5>
            <button type="button" class="close" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row pt-0">
                <div class="col-md-12">
                   Do you really want to delete:
                   <h5>{{objToDelete.set_tasks_title}} - {{objToDelete.set_description}}?</h5>
                   {{ (formatDate(objToDelete.record_date_finish) !== null && objToDelete.record_date_finish != '0000-00-00') ? (formatDate(objToDelete.record_date_finish) | date: 'dd MMM yyyy') : "No Date"  }}
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-danger"  (click)="deleteObj(objToDelete)">Delete</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
</ng-template>
<!-- END OF MODAL DELETE OBJECT FORM -->

    <!-- START OF RESET OBJECT FORM -->
<ng-template #modalResetInduction let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Reset Induction</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Do you really want to reset:
               <h5>{{objToReset.set_tasks_title}} - {{objToReset.set_description}}?</h5>
               {{ (formatDate(objToReset.record_date_finish) !== null && objToReset.record_date_finish != '0000-00-00') ? (formatDate(objToReset.record_date_finish) | date: 'dd MMM yyyy') : "No Date"  }}
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger"  (click)="resetInductionRecord(objToReset.record_id)">Reset</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL RESET OBJECT FORM -->


 <!-- START OF RETRAIN OBJECT FORM -->
 <ng-template #modalRetrainInduction let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Retrain Induction</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Do you really want for {{origin}} to retrain this induction?
               <h5>{{objToRetrain.set_tasks_title}} - {{objToRetrain.set_description}}?</h5>
               {{ (formatDate(objToRetrain.record_date_finish) !== null && objToRetrain.record_date_finish != '0000-00-00') ? (formatDate(objToRetrain.record_date_finish) | date: 'dd MMM yyyy') : "No Date"  }}
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger"  (click)="retrainInductionRecord(objToRetrain)">Retrain</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL RESET OBJECT FORM -->

<!-- START OF BULK RETRAIN INDUCTION MODAL  -->
<ng-template #modalBulkRetrain let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Mark All for Retraining</h5>
        <button type="button" class="close" (click)="resetBulkRetrainVariables();close();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12" *ngIf="this.bulk_count > 0">
                <span> There are total of <strong style="color:red">{{bulk_count}}</strong> to mark for retrain.</span><br/>
                <div *ngFor="let i of selected_bulk_retrain" style="display:inline-block">
                    <span style="color:blue">&#8226;</span>&nbsp; <small>{{i.set_task_type_name}}: &nbsp;<strong>({{i.set_tasks_title}})</strong></small> &nbsp;
                </div><br/>
            </div>
            <div class="col-md-12" *ngIf="bulk_count == 0">No selected induction for retrain.</div>
        </div>
    </div>
    <div class="modal-footer">
        <button *ngIf="bulk_count > 0" type="button" class="btn btn-sm btn-danger" (click)="bulkRetrainInduction()">Confirm</button>&nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="resetBulkRetrainVariables();close();">Cancel</button>
    </div>
</ng-template>
<!-- END OF BULK RETRAIN INDUCTION MODAL  -->


<!-- START OF REINDUCTION MODAL  -->
<ng-template #modalReinduction let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"><span><i class="fa fa fa-mortar-board"></i></span>&nbsp; Mark this user for Reinduction</h5>
        <button type="button" class="close" (click)="close();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12" >
                <span class="text-center"> Are you sure you want to continue?</span><br/>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button  type="button" class="btn btn-sm btn-danger" (click)="markUserReinduction();close();">Confirm</button>&nbsp;
        <button type="button" class="btn btn-sm btn-secondary" (click)="close();">Cancel</button>
    </div>
</ng-template>
<!-- END OF REINDUCTION MODAL  -->
